var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding"},[_c('ExpandableTable',{attrs:{"children":_vm.permissions_list,"fields":_vm.permissions_fields,"highlightable":""},on:{"cell_value_changed":_vm.checkbox_changed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }